import $ from 'jquery';
import {is_function} from '../../../Helpers/js';


$.fn.dataTables = function (options) {
    'use strict';


    window.Glossar.add({
        NEXT: {de: '>', en: '>'},
        PREVIOUS: {de: '<', en: '<'},
        ZERO_RECORDS: {de: 'Keine Einträge vorhanden', en: 'No matching records found'}

    });

    var $me = $(this);

    var limit = options.limit || $me.attr('data-limit');
    var defaultSettings = {
        ordering: true,
        searching: true,
        paging: limit ? true : false,
        info: limit ? true : false,
        pageLength: limit ? limit : 10,
        lengthChange: false,
        highlight: true,
        onDraw: null,
        autoWidth: false,
        columnDefs: [
            {
                'targets': 'no-sort',
                'orderable': false
            },
            {
                'targets': 'no-search',
                'searchable': false
            }
        ],
        drawCallback: function () {
            //	show pagination and info if there is more than one page
            var $pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate, .dataTables_info');
            $pagination.toggle(this.api().page.info().pages > 1);
            $(this).closest('.dataTables_wrapper').find('.pagination.menu').removeClass('stackable').addClass('unstackable');
            // -------Fixed table height on last page------
            // var total_count = settings.fnRecordsTotal();
            // var show_num = settings._iDisplayLength;
            // var tbody = $(this).children('tbody');
            // var tr_count = tbody.children('tr').length;
            // var missing = show_num - tr_count;
            //
            // // Wipe out any previously manually added margin-bottom values to the tables cells. This is done so
            // // a) we don't get rows with previously applied big margin bottoms appearing in the middle of the table making the table too big
            // // b) a row with a big margin bottoms isn't picked to calculate the row height which can throw the calculation waaayyy off course
            // // ('' removes the manual value and padding-bottom is recalculated from applicable css styles)
            // tbody.find('tr td').css('padding-bottom', '');
            //
            // if (show_num < total_count && missing > 0)
            // // now we can safely pick up the height for a row and make an appropriate padding-bottom value for the last row's cells
            // // so table keeps the same height
            // {
            // 	var lastRowHeight = tbody.find('tr:last-child').height();
            // }
            // var lastRowCells = tbody.find('tr:last-child td');
            // var existingPadding = parseFloat(lastRowCells.css('padding-bottom'));
            // //console.warn ("height", lastRowHeight, lastRowCells, existingPadding);
            // lastRowCells.css('padding-bottom', (existingPadding + (lastRowHeight * missing)) + 'px');
        },
        language: {
            'infoFiltered': '',
            'search': '', //input without label
            'zeroRecords': window.Glossar.getText('ZERO_RECORDS'),
            'paginate': {
                'next': window.Glossar.getText('NEXT'),
                'previous': window.Glossar.getText('PREVIOUS')
            }
        }
    };

    var settings = $.extend(true, defaultSettings, options);
    $.fn.DataTable.ext.pager.numbers_length = 5;

    var table = $me.DataTable(settings);
    setTimeout(function () {
        $me.DataTable().columns.adjust();
    }, 0);

    table.on('draw', function () {
        $me.highlight(table.search());
        if (is_function(settings.onDraw)) {
            settings.onDraw(table.search());
        }
    });

    $me.closest('.dataTables_wrapper').find('.dataTables_filter .ui.input').addClass('left icon').append('<i class="search icon"></i>');

    $me.highlight = function (str) {
        var $tbody = $me.find(table.table().body());
        $tbody.unhighlight();
        $tbody.find('tr[role="row"]').highlight(str);
    };

    return $me;
};

